export default __webpack_public_path__ + "static/media/BetCloudKB.75269310.png";